import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {StpRegistrationRoutingModule} from "../stp-registration/stp-registration-routing.module";
import {NgZorroAntdModule} from "../../ng-zorro-antd.module";
import {SharedModule} from "../../shared/modules/shared/shared.module";
import {FormsModule} from "@angular/forms";
import {NgxQRCodeModule} from "@techiediaries/ngx-qrcode";
import {QRCodeModule} from "angularx-qrcode";
import {LandingModule} from "../landing/landing.module";
import {ReCaptchaModule} from "../re-captcha/re-captcha.module";
import {NzCollapseModule} from "ng-zorro-antd/collapse";
import {AdminsDashboardComponent} from "./components/admins-dashboard/admins-dashboard.component";
import { CalendarComponent } from './components/calendar/calendar.component';


@NgModule({
  declarations: [
    AdminsDashboardComponent,
    CalendarComponent
  ],
  imports: [
    CommonModule,
    StpRegistrationRoutingModule,
    NgZorroAntdModule,
    SharedModule,
    FormsModule,
    NgxQRCodeModule,
    QRCodeModule,
    LandingModule,
    ReCaptchaModule,
    NzCollapseModule
  ],
  exports: [

  ],
})
export class AdminsDashboardModule {}
